// extracted by mini-css-extract-plugin
module.exports = {"actions":"SolutionPageHero_actions__xP7Sx","primaryCta":"SolutionPageHero_primaryCta__nFCqC"};